'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _theme = require('../theme');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line local-rules/no-deep-relative-imports

// const HTMLInput = styled('input')``;  // by default if the argument is string, styled will safe guard and just keep
// // these props https://github.com/emotion-js/emotion/pull/227/files#diff-3b32d1b61e2f150677d228cd4e2ec827R1
// // unless the argument is an function.

var HTMLInput = /*#__PURE__*/(0, _theme.styled)('input', {
  target: 'e1w3h5kh0'
})(function (_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled,
      hasError = _ref.hasError,
      height = _ref.height,
      required = _ref.required,
      success = _ref.success,
      width = _ref.width,
      variant = _ref.variant;

  var inputTheme = theme.components.input[variant];
  var errorState = !disabled && hasError && inputTheme ? inputTheme.error : {};
  var requiredState = !disabled && required && inputTheme ? inputTheme.required : {};
  var successState = !disabled && !hasError && inputTheme && success ? inputTheme.success : {};
  return (0, _extends3.default)({
    boxSizing: 'border-box',
    margin: 0
  }, inputTheme, {
    height: height,
    width: width
  }, errorState, requiredState, successState);
});

var Input = function (_React$PureComponent) {
  (0, _inherits3.default)(Input, _React$PureComponent);

  function Input() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Input);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref2, [this].concat(args))), _this), _this.handleOnBlur = function (e) {
      var _this$props = _this.props,
          max = _this$props.max,
          min = _this$props.min,
          onChange = _this$props.onChange,
          onBlur = _this$props.onBlur,
          type = _this$props.type;

      if (type === 'number') {
        var valueHasChanged = false;
        if (min !== undefined && min !== null && e.target.value < min) {
          e.target.value = min;
          valueHasChanged = true;
        }
        if (max !== undefined && e.target.value > max) {
          e.target.value = max;
          valueHasChanged = true;
        }
        if (onChange && valueHasChanged) {
          onChange(e);
        }
      }
      if (onBlur) {
        onBlur(e);
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Input, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          ariaDescribedBy = _props.ariaDescribedBy,
          ariaInvalid = _props.ariaInvalid,
          ariaLabel = _props.ariaLabel,
          ariaReadOnly = _props.ariaReadOnly,
          props = (0, _objectWithoutProperties3.default)(_props, ['ariaDescribedBy', 'ariaInvalid', 'ariaLabel', 'ariaReadOnly']);


      return _react2.default.createElement(HTMLInput, (0, _extends3.default)({}, props, {
        'aria-describedby': ariaDescribedBy,
        'aria-invalid': ariaInvalid,
        'aria-label': ariaLabel,
        'aria-readonly': ariaReadOnly
      }));
    }
  }]);
  return Input;
}(_react2.default.PureComponent);

Input.defaultProps = {
  type: 'text',
  variant: 'default'
};

exports.default = Input;